import { render, staticRenderFns } from "./car-follower-picker.vue?vue&type=template&id=647d9446&scoped=true&"
import script from "./car-follower-picker.vue?vue&type=script&lang=js&"
export * from "./car-follower-picker.vue?vue&type=script&lang=js&"
import style0 from "./car-follower-picker.vue?vue&type=style&index=0&id=647d9446&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d9446",
  null
  
)

export default component.exports